import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import InstallPromptBanner from "./components/InstallPromptBanner";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import StaffPage from "./pages/StaffPage";
import AgencyPage from "./pages/AgencyPage";
import DepositsPage from "./pages/DepositsPage";
import BookingsPage from "./pages/BookingsPage";
import RefundsPage from "./pages/RefundsPage";
import BalancePage from "./pages/BalancePage";
import DailyBalancePage from "./pages/DailyBalancePage";
import FundRequestsPage from "./pages/FundRequestsPage";
import AuditLogPage from "./pages/AuditLogPage";
import BulkBookingPage from "./pages/BulkBookingPage";
import AmazonRefundsPage from "./pages/AmazonRefundsPage";
import ReportsPage from "./pages/ReportsPage";
import WalletStatementPage from "./pages/WalletStatementPage";
import DistributorLedgerPage from "./pages/DistributorLedgerPage";
import PendingOpeningBalancesPage from "./pages/PendingOpeningBalancesPage";
import DistributorDashboard from "./pages/DistributorDashboard";
import DistributorSubmitBooking from "./pages/DistributorSubmitBooking";
import DistributorDocuments from "./pages/DistributorDocuments";
import DistributorFundRequestsPage from "./pages/DistributorFundRequestsPage";
import BookingFilesPage from "./pages/BookingFilesPage";
import StaffAssignedFilesPage from "./pages/StaffAssignedFilesPage";
import AutoAssignPage from "./pages/AutoAssignPage";
import Phase2PreviewPage from "./pages/Phase2PreviewPage";
import MyBookingWorkspacePage from "./pages/MyBookingWorkspacePage";
import MyTeamReportPage from "./pages/MyTeamReportPage";
import ComplaintsPage from "./pages/ComplaintsPage";
import ComplaintsHubPage from "./pages/ComplaintsHubPage";
import BbpsPage from "./pages/BbpsPage";
import BbpsAdminPage from "./pages/BbpsAdminPage";
import BalanceTransferPage from "./pages/BalanceTransferPage";
import BookingWorkspacePage from "./pages/BookingWorkspacePage";
import BookingHistoryPage from "./pages/BookingHistoryPage";
import AmazonAccountStockPage from "./pages/AmazonAccountStockPage";
import UsedAmazonAccountsPage from "./pages/UsedAmazonAccountsPage";
import MyAccountRequestsPage from "./pages/MyAccountRequestsPage";
import AccountRequestsAdminPage from "./pages/AccountRequestsAdminPage";
import CardStockPage from "./pages/CardStockPage";
import MyCardsPage from "./pages/MyCardsPage";
import MyCardHubPage from "./pages/MyCardHubPage";
import FailedBookingsLogPage from "./pages/FailedBookingsLogPage";
import CardAuditTrailPage from "./pages/CardAuditTrailPage";
import PendingReviewsPage from "./pages/PendingReviewsPage";
import IndaneExtractorPage from "./pages/IndaneExtractorPage";
import AmazonBalanceCheckerPage, { AmazonBalanceAccountsPage, AmazonBalanceAuditPage } from "./pages/AmazonBalancePages";
import BankStatementsPage from "./pages/BankStatementsPage";
import BankStatementDetailPage from "./pages/BankStatementDetailPage";
import TwoFactorSetupPage from "./pages/TwoFactorSetupPage";
import TwoFactorAdminPage from "./pages/TwoFactorAdminPage";
import VoucherExtractorPage from "./pages/VoucherExtractorPage";
import { ElectricityVendorUpload, ElectricityAdminFiles, ElectricityWorkspace, ElectricityVendorLedger } from "./pages/ElectricityPages";
import SalesPersonPage from "./pages/SalesPersonPage";
import PaymentRecoveryPage from "./pages/PaymentRecoveryPage";
import PlatformAccountsPage from "./pages/PlatformAccountsPage";
import QuickBookingPage from "./pages/QuickBookingPage";
import LpgCheckerPage from "./pages/LpgCheckerPage";
import AutomationPage from "./pages/AutomationPage";
import AgencyFilesPage from "./pages/AgencyFilesPage";
import InvoicesPage from "./pages/InvoicesPage";
import SettlementsPage from "./pages/SettlementsPage";
import CashbackTrackerPage from "./pages/CashbackTrackerPage";
import HpclMatcherPage from "./pages/HpclMatcherPage";
import HpclMatcherReviewPage from "./pages/HpclMatcherReviewPage";
import MyTeamPage from "./pages/MyTeamPage";
import ArchivedItemsPage from "./pages/ArchivedItemsPage";
import BackupPage from "./pages/BackupPage";
import BharatGasToolPage from "./pages/BharatGasToolPage";
import GiftCardVendorsPage from "./pages/GiftCardVendorsPage";
import DeletedVendorsPage from "./pages/DeletedVendorsPage";
import VoucherStockPage from "./pages/VoucherStockPage";
import VoucherComplaintsPage from "./pages/VoucherComplaintsPage";
import DuplicateVoucherLogPage from "./pages/DuplicateVoucherLogPage";
import MyVouchersPage from "./pages/MyVouchersPage";
import VendorLedgersPage from "./pages/VendorLedgersPage";
import VendorGiftCardsPage from "./pages/VendorGiftCardsPage";
import CardVendorCardsPage from "./pages/CardVendorCardsPage";
import SecurityAuditPage from "./pages/SecurityAuditPage";
import RecoveryQueuePage from "./pages/RecoveryQueuePage";
import VendorLedgerPage from "./pages/VendorLedgerPage";
import VendorTransactionsPage from "./pages/VendorTransactionsPage";
import VendorFundRequestsPage from "./pages/VendorFundRequestsPage";
import AdminFundRequestsPage from "./pages/AdminFundRequestsPage";
import SettingsPage from "./pages/SettingsPage";
import TelegramConnectPage from "./pages/TelegramConnectPage";
import TestRunnerPage from "./pages/TestRunnerPage";
import DataResetPage from "./pages/DataResetPage";
import DataRecoveryPage from "./pages/DataRecoveryPage";
import BulkKhatabookImportPage from "./pages/BulkKhatabookImportPage";

import SupportPage from "./pages/SupportPage";
import ChatPage from "./pages/ChatPage";
import ChatHomePage from "./pages/ChatHomePage";
import ChatLedgerPage from "./pages/ChatLedgerPage";
import { TermsPage, PrivacyPage, RefundPolicyPage, GrievancePolicyPage, SupportHelpPage, DataDeletionPage, WhatsAppCompliancePage, AboutBusinessPage } from "./pages/PolicyPages";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/grievance-policy" element={<GrievancePolicyPage />} />
          <Route path="/support-help" element={<SupportHelpPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          <Route path="/whatsapp-compliance" element={<WhatsAppCompliancePage />} />
          <Route path="/about-business" element={<AboutBusinessPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/staff" element={<StaffPage view="staff" />} />
            <Route path="/distributors" element={<StaffPage view="distributors" />} />
            <Route path="/accountants" element={<StaffPage view="accountants" />} />
            <Route path="/agencies" element={<AgencyPage />} />
            <Route path="/deposits" element={<DepositsPage />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/bulk-booking" element={<BulkBookingPage />} />
            <Route path="/refunds" element={<RefundsPage />} />
            <Route path="/amazon-refunds" element={<AmazonRefundsPage />} />
            <Route path="/balance" element={<BalancePage />} />
            <Route path="/daily-balance" element={<DailyBalancePage />} />
            <Route path="/fund-requests" element={<FundRequestsPage />} />
            <Route path="/audit-log" element={<AuditLogPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/wallet-statement" element={<WalletStatementPage />} />
            <Route path="/distributor-ledger" element={<DistributorLedgerPage />} />
            <Route path="/pending-opening-balances" element={<PendingOpeningBalancesPage />} />
            <Route path="/distributor-dashboard" element={<DistributorDashboard />} />
            <Route path="/distributor-submit" element={<DistributorSubmitBooking />} />
            <Route path="/distributor-documents" element={<DistributorDocuments />} />
            <Route path="/distributor-fund-requests" element={<DistributorFundRequestsPage />} />
            <Route path="/booking-files" element={<BookingFilesPage />} />
            <Route path="/assigned-files" element={<StaffAssignedFilesPage />} />
            <Route path="/auto-assign" element={<AutoAssignPage />} />
            <Route path="/phase2-preview" element={<Phase2PreviewPage />} />
            <Route path="/my-booking-workspace" element={<MyBookingWorkspacePage />} />
            <Route path="/my-team-report" element={<MyTeamReportPage />} />
            <Route path="/complaints" element={<ComplaintsPage />} />
            <Route path="/complaints-hub" element={<ComplaintsHubPage />} />
            <Route path="/bbps" element={<BbpsPage />} />
            <Route path="/bbps-admin" element={<BbpsAdminPage />} />
            <Route path="/balance-transfer" element={<BalanceTransferPage />} />
            <Route path="/booking-workspace/:fileId" element={<BookingWorkspacePage />} />
            <Route path="/booking-history" element={<BookingHistoryPage />} />
            <Route path="/account-stock" element={<AmazonAccountStockPage />} />
            <Route path="/used-amazon-accounts" element={<UsedAmazonAccountsPage />} />
            <Route path="/my-account-requests" element={<MyAccountRequestsPage />} />
            <Route path="/account-requests" element={<AccountRequestsAdminPage />} />
            <Route path="/sales-persons" element={<SalesPersonPage />} />
            <Route path="/payment-recovery" element={<PaymentRecoveryPage />} />
            <Route path="/platform-accounts" element={<PlatformAccountsPage />} />
            <Route path="/quick-booking" element={<QuickBookingPage />} />
            <Route path="/lpg-checker" element={<LpgCheckerPage />} />
            <Route path="/automation" element={<AutomationPage />} />
            <Route path="/agency-files" element={<AgencyFilesPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/settlements" element={<SettlementsPage />} />
            <Route path="/cashback" element={<CashbackTrackerPage />} />
            <Route path="/hpcl-matcher" element={<HpclMatcherPage />} />
            <Route path="/hpcl-matcher/review/:reportId" element={<HpclMatcherReviewPage />} />
            <Route path="/my-team" element={<MyTeamPage />} />
            <Route path="/archived" element={<ArchivedItemsPage />} />
            <Route path="/backup" element={<BackupPage />} />
            <Route path="/bharat-gas-tool" element={<BharatGasToolPage />} />
            <Route path="/gift-card-vendors" element={<GiftCardVendorsPage />} />
            <Route path="/vendors/:id" element={<GiftCardVendorsPage />} />
            <Route path="/deleted-vendors" element={<DeletedVendorsPage />} />
            <Route path="/voucher-stock" element={<VoucherStockPage />} />
            <Route path="/card-stock" element={<CardStockPage />} />
            <Route path="/my-cards" element={<MyCardsPage />} />
            <Route path="/my-card-hub" element={<MyCardHubPage />} />
            <Route path="/failed-bookings-log" element={<FailedBookingsLogPage />} />
            <Route path="/pending-reviews" element={<PendingReviewsPage />} />
            <Route path="/indane-extractor" element={<IndaneExtractorPage />} />
            <Route path="/amazon-balance" element={<AmazonBalanceCheckerPage />} />
            <Route path="/amazon-balance/accounts" element={<AmazonBalanceAccountsPage />} />
            <Route path="/amazon-balance/audit" element={<AmazonBalanceAuditPage />} />
            <Route path="/bank-statements" element={<BankStatementsPage />} />
            <Route path="/bank-statements/:id" element={<BankStatementDetailPage />} />
            <Route path="/security/2fa" element={<TwoFactorSetupPage />} />
            <Route path="/security/2fa-admin" element={<TwoFactorAdminPage />} />
            <Route path="/admin/voucher-extractor" element={<VoucherExtractorPage />} />
            <Route path="/electricity-vendor/upload" element={<ElectricityVendorUpload />} />
            <Route path="/electricity-files" element={<ElectricityAdminFiles />} />
            <Route path="/electricity-workspace" element={<ElectricityWorkspace />} />
            <Route path="/electricity-ledger" element={<ElectricityVendorLedger />} />
            <Route path="/card-audit-trail" element={<CardAuditTrailPage />} />
            <Route path="/voucher-complaints" element={<VoucherComplaintsPage />} />
            <Route path="/duplicate-voucher-log" element={<DuplicateVoucherLogPage />} />
            <Route path="/my-vouchers" element={<MyVouchersPage />} />
            <Route path="/vendor-ledgers" element={<VendorLedgersPage />} />
            <Route path="/vendor-ledgers/:typeSlug" element={<VendorLedgersPage />} />
            <Route path="/vendor/all-gift-cards" element={<VendorGiftCardsPage />} />
            <Route path="/vendor/ledger" element={<VendorLedgerPage />} />
            <Route path="/vendor/transactions" element={<VendorTransactionsPage />} />
            <Route path="/vendor/wb-request" element={<VendorFundRequestsPage />} />
            <Route path="/vendor/my-cards" element={<CardVendorCardsPage />} />
            <Route path="/admin/vendor-cards" element={<CardVendorCardsPage />} />
            <Route path="/admin/security-audit" element={<SecurityAuditPage />} />
            <Route path="/admin/recovery-queue" element={<RecoveryQueuePage />} />
            <Route path="/admin/fund-requests" element={<AdminFundRequestsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin/test-runs" element={<TestRunnerPage />} />
            <Route path="/admin/data-reset" element={<DataResetPage />} />
            <Route path="/admin/data-recovery" element={<DataRecoveryPage />} />
            <Route path="/admin/bulk-khatabook" element={<BulkKhatabookImportPage />} />
            <Route path="/telegram" element={<TelegramConnectPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/chat" element={<ChatHomePage />} />
            <Route path="/chat/messages" element={<ChatPage />} />
            <Route path="/chat/ledger" element={<ChatLedgerPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <InstallPromptBanner />
    </AuthProvider>
  );
}

export default App;
